import { getEnvironmentFromHostname } from './urlUtils.js';
function getEnvHost() {
    const prodHost = 'https://api.squareup.com';
    const stagingHost = 'https://api.squareupstaging.com';
    const env = getEnvironmentFromHostname(window.location.hostname);
    return env === 'production' ? prodHost : stagingHost;
}
export function mapMessagesToSpotlightItems(placementMessages) {
    return placementMessages.map((message) => {
        const messageBody = JSON.parse(message.default_format.body);
        const messageBodyBody = JSON.parse(messageBody.body);
        const spotlightItem = {
            messageId: message.message_id,
            requestToken: message.request_token,
            placementId: message.placementId,
            description: messageBodyBody.message,
            id: message.message_id,
            image: {
                description: messageBodyBody.message,
                id: `${message.message_id}-image`,
                title: messageBodyBody.title,
                url: messageBody.icon.url,
            },
            linkText: messageBodyBody.title,
            title: messageBodyBody.title,
            url: messageBody.buttons.link.url,
        };
        return spotlightItem;
    });
}
export function fetchPlacementMessages(placementIds) {
    const messagesUrl = `${getEnvHost()}/api/v2/messages/bulk`;
    const placementRequestObjs = placementIds.map((placementId) => ({
        placement_id: placementId,
        limit: 1,
        locale: document.documentElement.lang ? document.documentElement.lang.replace('-', '_').toUpperCase() : 'EN_US',
        entity: { type: 2, token: 'PUBLIC' },
    }));
    const payloadBody = {
        requests: placementRequestObjs,
    };
    const payload = {
        method: 'POST',
        mode: 'cors',
        headers: {
            'Content-Type': 'application/json',
        },
        referrerPolicy: 'no-referrer',
        body: JSON.stringify(payloadBody),
    };
    return fetch(messagesUrl, payload)
        .then((response) => response.json())
        .then((data) => {
        if (data.responses) {
            const placementMessages = [];
            // endusre order of returned messages matches order of placement ids from input
            placementIds.forEach((placementId) => {
                const placementMessageUnits = (data.responses[placementId] || {}).message_units;
                if (placementMessageUnits && placementMessageUnits.length > 0) {
                    placementMessages.push({
                        ...placementMessageUnits[0],
                        placementId,
                    });
                }
            });
            return placementMessages;
        }
        return [];
    })
        .catch((error) => {
        throw new Error('PublicWebNav: Unable to fetch placement data', error);
    });
}
